<template>
  <div class="content_box">
    <div class="part1_box clearfix">
      <div class="title">工业增加值情况</div>
      <el-row :gutter="10">
        <el-col :xs="24" :lg="10">
          <div id="map"></div>
        </el-col>
        <el-col style="padding-top: 20px" :xs="24" :lg="14">
          <div style="position: relative">
            <el-radio-group
              v-model="radio"
              class="title"
              style="
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                float: left;
              "
            >
              <el-radio :label="0" @change.native="cutTableList()"
                >当月</el-radio
              >
              <el-radio :label="1" @change.native="cutTableList()"
                >本年累计</el-radio
              >
            </el-radio-group>
            <el-date-picker
              class="phone_date"
              :editable="false"
              :clearable="false"
              style="position: absolute; right: 0; top: -6px"
              v-model="rangeTime"
              type="month"
              placeholder="选择日期"
              @change="changeAreaTime1"
              size="mini"
            ></el-date-picker>
          </div>
          <el-table
            :data="dataListTable"
            style="width: 100%; text-align: center"
            :header-cell-style="{
              backgroundColor: '#DCDFE6',
              color: '#000',
            }"
          >
            <el-table-column
              fixed
              prop="name"
              label="市/区县"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column label="本年累计数据" align="center">
              <el-table-column
                prop="addThis"
                sortable
                label="工业增加值（亿元）"
              ></el-table-column>
              <el-table-column
                prop="addSync"
                sortable
                label="工业增加值增速（%）"
              ></el-table-column>
              <el-table-column
                prop="buThis"
                sortable
                label="工业投资（亿元）"
              ></el-table-column>
              <el-table-column
                prop="buSync"
                sortable
                label="工业投资增速（%）"
              ></el-table-column>
              <el-table-column
                prop="techThis"
                sortable
                label="工业技改投资（亿元）"
              ></el-table-column>
              <el-table-column
                prop="techSync"
                sortable
                label="工业技改投资增速（%）"
              ></el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <!-- 规上行业工业经济情况、企业占比情况 -->
    <el-row :gutter="10">
      <el-col :xs="24" :lg="12">
        <div class="part_2 part_box_1">
          <div class="title">
            规上行业工业经济情况
            <el-date-picker
              class="phone_date"
              :editable="false"
              :clearable="false"
              v-model="gyjgTime"
              type="month"
              placeholder="选择日期"
              @change="changeGyjgTime"
              size="mini"
            ></el-date-picker>
          </div>
          <div class="button">
            <el-button
              :type="nowGyjgBtn == '工业增加值' ? 'primary' : ''"
              size="small"
              round
              @click="changeGyjgBtn('工业增加值')"
              >工业增加值</el-button
            >
            <el-button
              :type="nowGyjgBtn == '营业收入' ? 'primary' : ''"
              size="small"
              round
              @click="changeGyjgBtn('营业收入')"
              >营业收入</el-button
            >
            <el-button
              :type="nowGyjgBtn == '利润总额' ? 'primary' : ''"
              size="small"
              round
              @click="changeGyjgBtn('利润总额')"
              >利润总额</el-button
            >
          </div>
          <div class="chartBox">
            <div class="gyjgLeft" id="gyjgLeft"></div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :lg="12">
        <div class="part_2 part_box_1">
          <div class="title">
            企业占比情况
            <el-date-picker
              class="phone_date"
              :editable="false"
              :clearable="false"
              v-model="zbtime"
              type="month"
              placeholder="选择日期"
              @change="changeZbTime"
              size="mini"
            ></el-date-picker>
          </div>
          <div class="button">
            <el-button
              :type="nowZbBtn == 1 ? 'primary' : ''"
              size="small"
              round
              @click="changeZbBtn(1)"
              >全部企业占比</el-button
            >
            <el-button
              :type="nowZbBtn == 0 ? 'primary' : ''"
              size="small"
              round
              @click="changeZbBtn(0)"
              >规上企业占比</el-button
            >
          </div>
          <div class="chartBox">
            <div class="ZbLeft" id="ZbLeft"></div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 企业数据统计、各区县企业数 -->
    <el-row :gutter="10">
      <el-col :xs="24" :lg="12">
        <div class="part_2 part_box_1">
          <div class="title">
            企业数据统计
            <el-date-picker
              class="phone_date"
              :editable="false"
              :clearable="false"
              v-model="qyxzTime"
              type="month"
              placeholder="选择日期"
              @change="changeQyxzTime"
              size="mini"
            ></el-date-picker>
          </div>

          <div class="chartBox">
            <div id="qyxz"></div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :lg="12">
        <div class="part_2 part_box_1">
          <div class="title">
            各区县企业数
            <el-date-picker
              class="phone_date"
              :editable="false"
              :clearable="false"
              v-model="companyNumTime"
              type="month"
              placeholder="选择日期"
              @change="changeCompanyNumTime"
              size="mini"
            ></el-date-picker>
          </div>
          <div class="chartBox">
            <div id="companyNum"></div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="part_2">
      <div class="title">
        区域监测情况
        <el-date-picker
          class="phone_date"
          :editable="false"
          :clearable="false"
          v-model="time"
          type="month"
          placeholder="选择日期"
          @change="changeAreaTime"
          size="mini"
        ></el-date-picker>
      </div>
      <div class="title" style="margin-top: 10px">
        <div class="button">
          <el-button
            :type="nowAreaBtn == '工业增加值' ? 'primary' : ''"
            size="small"
            round
            @click="changeAreaBtn('工业增加值')"
            >工业增加值</el-button
          >
          <el-button
            :type="nowAreaBtn == '营业收入' ? 'primary' : ''"
            size="small"
            round
            @click="changeAreaBtn('营业收入')"
            >营业收入</el-button
          >
          <el-button
            :type="nowAreaBtn == '利润总额' ? 'primary' : ''"
            size="small"
            round
            @click="changeAreaBtn('利润总额')"
            >利润总额</el-button
          >
        </div>
      </div>
      <el-row>
        <el-col :xs="24" :lg="12">
          <div class="areaChartsLeft divHeight"></div>
        </el-col>
        <el-col :xs="24" :lg="12">
          <div class="areaChartsRight divHeight"></div>
        </el-col>
      </el-row>
    </div>
    <div class="part_2">
      <div class="title">
        投资监测情况
        <el-date-picker
          class="phone_date"
          :editable="false"
          :clearable="false"
          v-model="investTime"
          type="month"
          placeholder="选择日期"
          @change="changeInvestTime"
          size="mini"
        ></el-date-picker>
      </div>
      <div class="title" style="margin-top: 10px">
        <div class="button">
          <el-button
            :type="nowInvestBtn == '工业投资' ? 'primary' : ''"
            size="small"
            round
            @click="changeInvestBtn('工业投资')"
            >工业投资</el-button
          >
          <el-button
            :type="nowInvestBtn == '技改投资' ? 'primary' : ''"
            size="small"
            round
            @click="changeInvestBtn('技改投资')"
            >技改投资</el-button
          >
        </div>
      </div>
      <el-row>
        <el-col :xs="24" :lg="12">
          <div class="industryChartsLeft divHeight"></div>
        </el-col>
        <el-col :xs="24" :lg="12">
          <div class="industryChartsRight divHeight"></div>
        </el-col>
      </el-row>
    </div>
    <div class="part_2">
      <div class="title">
        园区监测情况

        <el-date-picker
          class="phone_date"
          :editable="false"
          :clearable="false"
          v-if="dataRange === 'month'"
          v-model="gardenTime"
          type="month"
          placeholder="选择日期"
          value-format="yyyy-MM"
          @change="changeGardenTime()"
          size="mini"
        ></el-date-picker>
        <div v-if="dataRange === 'quarter'">
          <quarter
            style="margin-left: 20px"
            :default-value="defaultQuarterValue"
            v-on:getQuarter="getQuarter"
          ></quarter>
        </div>
        <div v-if="dataRange === 'halfyear'">
          <halfYear
            style="margin-left: 20px"
            :default-value="defaultQuarterValue"
            v-on:getQuarter="getHalfYear"
          ></halfYear>
        </div>
        <el-date-picker
          class="phone_date"
          :editable="false"
          :clearable="false"
          v-if="dataRange === 'year'"
          v-model="yearVal"
          type="year"
          placeholder="选择年"
          value-format="yyyy"
          @change="changeGardenTime1()"
          size="mini"
        >
        </el-date-picker>
      </div>
      <div class="title" style="margin-top: 10px">
        <div class="button">
          <el-button
            :type="nowGardenBtn == '工业销售产值' ? 'primary' : ''"
            size="small"
            round
            @click="changeGardenBtn('工业销售产值')"
            >工业销售产值</el-button
          >
          <el-button
            :type="nowGardenBtn == '营业收入' ? 'primary' : ''"
            size="small"
            round
            @click="changeGardenBtn('营业收入')"
            >营业收入</el-button
          >
          <el-button
            :type="nowGardenBtn == '工业总产值' ? 'primary' : ''"
            size="small"
            round
            @click="changeGardenBtn('工业总产值')"
            >工业总产值</el-button
          >
          <el-button
            :type="nowGardenBtn == '规模工业企业营业收入' ? 'primary' : ''"
            size="small"
            round
            @click="changeGardenBtn('规模工业企业营业收入')"
            >规模工业企业营业收入</el-button
          >
        </div>
      </div>
      <el-row>
        <el-col :xs="24" :lg="12">
          <div class="gardenChartsLeft divHeight"></div>
        </el-col>
        <el-col :xs="24" :lg="12">
          <div class="gardenChartsRight divHeight"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  workBenchAreaL,
  workBenchAreaR,
  workBenchIndustryL,
  workBenchIndustryR,
  workBenchGardenL,
  workBenchGardenR,
} from "@/utils/echarts_set.js";
import { mapGetters } from "vuex";
import echarts from "echarts";
import quarter from "@/components/dateUtils/quarter1.vue";
import halfYear from "@/components/dateUtils/halfYear1.vue";
export default {
  data() {
    return {
      dataRange: "year",
      yearVal: "",
      radio: 1,
      zbtime: "",
      gyjgTime: "",
      companyNumTime: "",
      qyxzTime: "",
      time: "",
      investTime: "",
      gardenTime: "",
      rangeTime: "",
      dateRangeTime: "2020-06",
      geoCoordMap: {},
      dataList: [],
      dataListTable: [],
      nowGardenBtn: "工业销售产值",
      nowInvestBtn: "工业投资",
      nowAreaBtn: "工业增加值",
      nowGyjgBtn: "工业增加值",
      nowZbBtn: 1,
      DataMax: 0,
      DataMin: 0,
      quarter: "",
      times: "",
      halfyeartime: "",
      defaultQuarterValue: "",
      defaultMonthValue: "",
      cheTime: "",
    };
  },
  components: {
    quarter,
    halfYear,
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },

  methods: {
    getQuarter(value) {
      this.year = value.split(",")[0].slice(0, 4);
      let temp = "";
      if (value.split(",")[0].slice(5, 7) === "01") {
        this.quarter = 1;
        temp = this.year + "-03";
      } else if (value.split(",")[0].slice(5, 7) === "04") {
        this.quarter = 2;
        temp = this.year + "-06";
      } else if (value.split(",")[0].slice(5, 7) === "07") {
        this.quarter = 3;
        temp = this.year + "-09";
      } else if (value.split(",")[0].slice(5, 7) === "10") {
        this.quarter = 4;
        temp = this.year + "-12";
      }
      this.times =
        this.defaultMonthValue > temp ? temp : this.defaultMonthValue;
      let time;
      if (this.quarter == 1) {
        time = this.year + "-01";
      } else if (this.quarter == 2) {
        time = this.year + "-04";
      } else if (this.quarter == 3) {
        time = this.year + "-07";
      } else if (this.quarter == 4) {
        time = this.year + "-10";
      }
      this.cheTime = time;
      this.changeGardenBtn(this.nowGardenBtn, this.cheTime);
      // this.initData();
    },
    getHalfYear(value) {
      this.year = value.split(",")[0].slice(0, 4);
      let temp = "";
      if (value.split(",")[0].slice(5, 7) === "01") {
        this.halfyeartime = 1;
        temp = this.year + "-03";
      } else if (value.split(",")[0].slice(5, 7) === "04") {
        this.halfyeartime = 2;
        temp = this.year + "-06";
      } else if (value.split(",")[0].slice(5, 7) === "07") {
        this.halfyeartime = 3;
        temp = this.year + "-09";
      } else if (value.split(",")[0].slice(5, 7) === "10") {
        this.halfyeartime = 4;
        temp = this.year + "-12";
      }
      this.times =
        this.defaultMonthValue > temp ? temp : this.defaultMonthValue;
      let time;
      if (this.halfyeartime == 1) {
        time = this.year + "-01";
      } else {
        time = this.year + "-07";
      }
      this.cheTime = time;
      this.changeGardenBtn(this.nowGardenBtn, this.cheTime);
      // this.initData();
    },
    changeZbTime(time) {
      this.changeZbBtn(this.nowZbBtn);
    },
    changeZbBtn(type) {
      this.nowZbBtn = type;
      if (this.zbtime == "") {
        this.zbtime = new Date();
      }
      var timePms = `${this.zbtime.getFullYear()}-${this.need0(
        this.zbtime.getMonth() + 1
      )}`;

      this.$axios
        .get(`/business/upgrade/home/companyProp?type=${type}`)
        .then((res) => {
          let zbList = [];
          res.data.data.map((item) => {
            for (let key in item) {
              if (key == "count") {
                item["value"] = item[key]; //在对象中添加了myId键名,并把当前key值赋值给了myId
                delete item[key]; //删除当前键名为id的属性
              }
            }
            zbList[zbList.length] = item;
          });
          let dataZb = {
            unit: "个",
            title: "",
            data: zbList,
          };
          this.circle("ZbLeft", dataZb);
        });
    },

    changeGyjgTime(time) {
      this.changeGyjgBtn(this.nowGyjgBtn);
    },
    changeGyjgBtn(type) {
      this.nowGyjgBtn = type;
      if (this.gyjgTime == "") {
        this.gyjgTime = new Date();
      }
      var timePms = `${this.gyjgTime.getFullYear()}-${this.need0(
        this.gyjgTime.getMonth() + 1
      )}`;

      this.$axios
        .get(
          `/business/upgrade/home/threeIndustryStatistics?dateRange=${timePms}`
        )
        .then((res) => {
          let zbList = [];
          res.data.data.map((item) => {
            function getValue(str) {
              for (let key in item) {
                if (key == str) {
                  item["value"] = item[key] == null ? 0 : item[key]; //在对象中添加了myId键名,并把当前key值赋值给了myId
                  delete item[key]; //删除当前键名为id的属性
                }
              }
            }

            if (type == "工业增加值") {
              getValue("addThis");
            }
            if (type == "营业收入") {
              getValue("busThis");
            }
            if (type == "利润总额") {
              getValue("profitProp");
            }
            zbList[zbList.length] = item;
          });

          let dataG = {
            unit: "亿元",
            title: "",
            data: zbList,
          };
          this.circle("gyjgLeft", dataG);
        });
    },

    circle(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      var option = {
        // title: {
        //   text: "单位：" + data.unit,
        //   x: "center",
        //   y: "center",
        //   textStyle: {
        //     fontSize: 12,
        //   },
        // },
        color: ["#009944", "#26c9ff", "#fe6327", "#e99b30", "#c03103"],
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b} : {c} 家 ( {d}% )",
          confine: true,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["30%", "60%"],
            center: ["50%", "50%"],
            minAngle: 0, //最小角度
            startAngle: 0, //起始角度
            data: data.data,
            label: {
              // normal: {
              //   position: "inside", //此处将展示的文字在内部展示
              // },
              formatter: "{b|{b}} \n {per|{d}%} ",
              padding: 4,
              rich: {
                b: {
                  color: "#333",
                  fontSize: 14,
                  lineHeight: 14,
                },
                per: {
                  color: "#333",
                  fontSize: 14,
                },
              },
            },
          },
        ],
      };
      chart.setOption(option);
    },

    //环状图绘制  结束

    changeCompanyNumTime() {
      if (this.companyNumTime == "") {
        this.companyNumTime = new Date();
      }
      var timePms = `${this.companyNumTime.getFullYear()}-${this.need0(
        this.companyNumTime.getMonth() + 1
      )}`;

      this.$axios
        .get(`/business/upgrade/home/selectDistrictCompany`)
        .then((res) => {
          let Num = { name: [], value: [] };
          res.data.data.map((item) => {
            Num.name[Num.name.length] = item.district;
            Num.value[Num.value.length] = item.count;
          });
          this.bar("companyNum", Num);
        });
    },

    changeQyxzTime() {
      if (this.qyxzTime == "") {
        this.qyxzTime = new Date();
      }
      var timePms = `${this.qyxzTime.getFullYear()}-${this.need0(
        this.qyxzTime.getMonth() + 1
      )}`;

      this.$axios
        .get(
          `/business/upgrade/home/companyNatureStatistics?type=1&dateRange=${timePms}`
        )
        .then((res) => {
          let nameList = [];
          let syList = [];
          res.data.data.map((item) => {
            nameList[nameList.length] = item.name;
            syList[syList.length] = item.thisMonth;
          });
          this.$axios
            .get(
              `/business/upgrade/home/companyNatureStatistics?type=0&dateRange=${timePms}`
            )
            .then((res2) => {
              let gyList = [];
              res2.data.data.map((item) => {
                gyList[gyList.length] = item.thisMonth;
              });

              let Dlist = [["企业性质", "国有企业", "民营企业"]];
              for (let i = 0; i < nameList.length; i++) {
                Dlist[Dlist.length + 1] = [nameList[i], syList[i], gyList[i]];
              }
              function removeEmpty(arr) {
                for (var i = 0; i < arr.length; i++) {
                  if (arr[i] == "" || typeof arr[i] == "undefined") {
                    arr.splice(i, 1);
                    i = i - 1;
                  }
                }
                return arr;
              }
              removeEmpty(Dlist);
              this.bar1("qyxz", Dlist);
            });
        });
    },

    /**直方图开始 */
    bar(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      let option = {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#96f691" },
          { offset: 0.5, color: "#68eef0" },
          { offset: 1, color: "#8cccf0" },
        ]),
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "30px",
          right: "30px",
          bottom: "30px",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data.name,
            axisLabel: {
              interval: 0,
              rotate: 20,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：个",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          {
            name: "企业数",
            type: "bar",
            barMaxWidth: 30,
            data: data.value,
          },
        ],
      };
      chart.setOption(option);
    },
    bar1(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          textStyle: {
            fontSize: 14,
          },
        },
        grid: {
          left: "30px",
          right: "32px",
          bottom: "30px",
          containLabel: true,
        },
        dataset: {
          source: data,
        },
        xAxis: [
          {
            type: "category",
            // data: data.name,
            axisLabel: {
              interval: 0,
              rotate: 20,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：亿元",
            axisLabel: {
              formatter: "{value}",
            },
          },
          {
            type: "value",
            name: "单位：kw/h",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],

        series: [
          {
            // name: "企业数",
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#72acf6" },
                { offset: 0.5, color: "#9c9ff0" },
                { offset: 1, color: "#9979f0" },
              ]),
            },
            barMaxWidth: 30,
            // data: data.value,
          },
          {
            // name: "企业数",
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#96f691" },
                { offset: 0.5, color: "#68eef0" },
                { offset: 1, color: "#8cccf0" },
              ]),
            },
            barMaxWidth: 30,
            // data: data.value,
          },
        ],
      };
      chart.setOption(option);
    },
    /**直方图结束 */

    changeGardenBtn(type) {
      this.nowGardenBtn = type;

      this.$axios
        .get(
          `/business/workBench/searchParkDetection/${this.nowGardenBtn}/${this.cheTime}`
        )
        .then((res) => {
          var Flist = [];
          var Slist = [];
          var Llist = [];
          var Nlist = [];
          var FlistR = [];
          var SlistR = [];
          var LlistR = [];
          var NlistR = [];
          if (res.data.parkTrend.length > 0) {
            for (let i = 0; i < res.data.parkTrend.length; i++) {
              Llist[Llist.length] = res.data.parkTrend[i].growthRate;
              Flist[Flist.length] = res.data.parkTrend[i].currentValue;
              Nlist[Nlist.length] = res.data.parkTrend[i].month;
              Slist[Slist.length] = res.data.parkTrend[i].lastValue;
            }
          }

          if (res.data.parkMsg.length > 0) {
            for (let i = 0; i < res.data.parkMsg.length; i++) {
              LlistR[LlistR.length] = res.data.parkMsg[i].growthRate;
              FlistR[FlistR.length] = res.data.parkMsg[i].currentValue;
              NlistR[NlistR.length] = res.data.parkMsg[i].name;
              SlistR[SlistR.length] = res.data.parkMsg[i].lastValue;
            }
          }

          var dataObj = {
            leftDataPark: {
              lineChartData: [],
              xaxis: [],
              yaxisFirst: [],
              yaxisSecond: [],
            },
            rightDataPark: {
              lineChartData: [],
              xaxis: [],
              yaxisFirst: [],
              yaxisSecond: [],
            },
          };

          dataObj.leftDataPark.lineChartData = Llist;
          dataObj.leftDataPark.xaxis = Nlist;
          dataObj.leftDataPark.yaxisFirst = Flist;
          dataObj.leftDataPark.yaxisSecond = Slist;
          dataObj.rightDataPark.lineChartData = LlistR;
          dataObj.rightDataPark.xaxis = NlistR;
          dataObj.rightDataPark.yaxisFirst = FlistR;
          dataObj.rightDataPark.yaxisSecond = SlistR;

          console.log("dataObj", dataObj);

          dataObj.title = this.nowGardenBtn;
          var yqjcData_lineL = [];
          var yqjcData_firstL = [];
          var yqjcData_secondL = [];
          var yqjcData_lineR = [];
          var yqjcData_firstR = [];
          var yqjcData_secondR = [];
          console.log(res.data);
          function clData(a, b) {
            for (let i = 0; i < a.length; i++) {
              if (a[i] == 0) {
                b[i] = "--";
              } else {
                b[i] = a[i];
              }
            }
          }

          clData(dataObj.leftDataPark.lineChartData, yqjcData_lineL);
          clData(dataObj.leftDataPark.yaxisFirst, yqjcData_firstL);
          clData(dataObj.leftDataPark.yaxisSecond, yqjcData_secondL);
          clData(dataObj.rightDataPark.lineChartData, yqjcData_lineR);
          clData(dataObj.rightDataPark.yaxisFirst, yqjcData_firstR);
          clData(dataObj.rightDataPark.yaxisSecond, yqjcData_secondR);
          dataObj.leftDataPark.lineChartData = yqjcData_lineL;
          dataObj.leftDataPark.yaxisFirst = yqjcData_firstL;
          dataObj.leftDataPark.yaxisSecond = yqjcData_secondL;
          dataObj.rightDataPark.lineChartData = yqjcData_lineR;
          dataObj.rightDataPark.yaxisFirst = yqjcData_firstR;
          dataObj.rightDataPark.yaxisSecond = yqjcData_secondR;
          this.gardenEcharts(dataObj);
        });
    },
    need0(num) {
      if (num > 9) {
        return num;
      } else {
        return `0${num}`;
      }
    },
    changeGardenTime() {
      this.cheTime = this.gardenTime;
      this.changeGardenBtn(this.nowGardenBtn);
    },
    changeGardenTime1() {
      this.cheTime = this.yearVal + "-01";
      this.changeGardenBtn(this.nowGardenBtn);
    },
    changeInvestBtn(type) {
      this.nowInvestBtn = type;
      if (this.investTime == "") {
        this.investTime = new Date();
      }
      var timePms = `${this.investTime.getFullYear()}-${this.need0(
        this.investTime.getMonth() + 1
      )}`;
      this.$axios
        .get(
          `/business/workBench/searchInvestmentDetection/${this.nowInvestBtn}/${timePms}`
        )
        .then((res) => {
          res.data.title = this.nowInvestBtn;
          var yqjcData_lineL = [];
          var yqjcData_firstL = [];
          var yqjcData_secondL = [];
          var yqjcData_lineR = [];
          var yqjcData_firstR = [];
          var yqjcData_secondR = [];

          function clData(a, b) {
            for (let i = 0; i < a.length; i++) {
              if (a[i] == 0) {
                b[i] = "--";
              } else {
                b[i] = a[i];
              }
            }
          }

          clData(res.data.leftDataInvestment.lineChartData, yqjcData_lineL);
          clData(res.data.leftDataInvestment.yaxisFirst, yqjcData_firstL);
          clData(res.data.leftDataInvestment.yaxisSecond, yqjcData_secondL);
          clData(res.data.rightDataInvestment.lineChartData, yqjcData_lineR);
          clData(res.data.rightDataInvestment.yaxisFirst, yqjcData_firstR);
          clData(res.data.rightDataInvestment.yaxisSecond, yqjcData_secondR);

          res.data.leftDataInvestment.lineChartData = yqjcData_lineL;
          res.data.leftDataInvestment.yaxisFirst = yqjcData_firstL;
          res.data.leftDataInvestment.yaxisSecond = yqjcData_secondL;
          res.data.rightDataInvestment.lineChartData = yqjcData_lineR;
          res.data.rightDataInvestment.yaxisFirst = yqjcData_firstR;
          res.data.rightDataInvestment.yaxisSecond = yqjcData_secondR;
          this.investEcharts(res.data);
        });
    },
    changeInvestTime() {
      this.changeInvestBtn(this.nowInvestBtn);
    },
    changeAreaBtn(type) {
      this.nowAreaBtn = type;
      if (this.time == "") {
        this.time = new Date();
      }
      var timePms = `${this.time.getFullYear()}-${this.need0(
        this.time.getMonth() + 1
      )}`;
      this.$axios
        .get(
          `/business/workBench/searchAreaDetection/${this.nowAreaBtn}/${timePms}`
        )
        .then((result) => {
          result.data.title = this.nowAreaBtn;
          var lineChartData = [];
          var yaxisFirst = [];
          var yaxisSecond = [];
          var xaxis = [];
          var lineChartData1 = [];
          var yaxisFirst1 = [];
          var yaxisSecond1 = [];
          var xaxis1 = [];
          var leftDataArea = {};
          var rightDataArea = {};

          var res = result.data;
          for (let i = 0; i < res.data.cityList.length; i++) {
            lineChartData[i] = res.data.cityList[i].grand;
            yaxisFirst[i] = res.data.cityList[i].now;
            yaxisSecond[i] = res.data.cityList[i].last;
            xaxis[i] = res.data.cityList[i].dateRange;
          }

          for (let i = 0; i < res.data.regionList.length; i++) {
            if (res.data.regionList[i] == null) {
              lineChartData1[i] = "";
              yaxisFirst1[i] = "";
              yaxisSecond1[i] = "";
              xaxis1[i] = "";
            } else {
              lineChartData1[i] = res.data.regionList[i].grand;
              yaxisFirst1[i] = res.data.regionList[i].now;
              yaxisSecond1[i] = res.data.regionList[i].last;
              xaxis1[i] = res.data.regionList[i].name;
            }
          }
          leftDataArea.lineChartData = lineChartData.reverse();
          leftDataArea.yaxisFirst = yaxisFirst.reverse();
          leftDataArea.yaxisSecond = yaxisSecond.reverse();
          leftDataArea.xaxis = xaxis.reverse();
          rightDataArea.lineChartData = lineChartData1;
          rightDataArea.yaxisFirst = yaxisFirst1;
          rightDataArea.yaxisSecond = yaxisSecond1;
          rightDataArea.xaxis = xaxis1;
          var newList = {
            leftDataArea: leftDataArea,
            rightDataArea: rightDataArea,
            title: this.nowAreaBtn,
          };

          var yqjcData_lineL = [];
          var yqjcData_firstL = [];
          var yqjcData_secondL = [];
          var yqjcData_lineR = [];
          var yqjcData_firstR = [];
          var yqjcData_secondR = [];

          function clData(a, b) {
            for (let i = 0; i < a.length; i++) {
              if (a[i] == 0) {
                b[i] = "--";
              } else {
                b[i] = a[i];
              }
            }
          }
          clData(newList.leftDataArea.lineChartData, yqjcData_lineL);
          clData(newList.leftDataArea.yaxisFirst, yqjcData_firstL);
          clData(newList.leftDataArea.yaxisSecond, yqjcData_secondL);
          clData(newList.rightDataArea.lineChartData, yqjcData_lineR);
          clData(newList.rightDataArea.yaxisFirst, yqjcData_firstR);
          clData(newList.rightDataArea.yaxisSecond, yqjcData_secondR);

          newList.leftDataArea.lineChartData = yqjcData_lineL;
          newList.leftDataArea.yaxisFirst = yqjcData_firstL;
          newList.leftDataArea.yaxisSecond = yqjcData_secondL;
          newList.rightDataArea.lineChartData = yqjcData_lineR;
          newList.rightDataArea.yaxisFirst = yqjcData_firstR;
          newList.rightDataArea.yaxisSecond = yqjcData_secondR;

          this.areaEcharts(newList);
        });
    },
    changeAreaTime(time) {
      this.changeAreaBtn(this.nowAreaBtn);
    },
    changeAreaTime1(time) {
      this.cutTableList();
    },
    cutTableList() {
      if (this.rangeTime == "") {
        this.rangeTime = new Date();
      }
      var timePms = `${this.rangeTime.getFullYear()}-${this.need0(
        this.rangeTime.getMonth() + 1
      )}`;

      this.$axios
        .get(
          `/business/workBench/searchIndustryIncreasedDetail/${this.radio}/${timePms}`
        )
        .then((res) => {
          if (res.data.length > 0) {
            res.data.forEach((item) => {
              item.addThis =
                item.addThis == 0 || item.addThis == null ? "--" : item.addThis;
              item.addSync =
                item.addSync == 0 || item.addSync == null ? "--" : item.addSync;
              item.buThis =
                item.buThis == 0 || item.buThis == null ? "--" : item.buThis;
              item.buSync =
                item.buSync == 0 || item.buSync == null ? "--" : item.buSync;
              item.techThis =
                item.techThis == 0 || item.techThis == null
                  ? "--"
                  : item.techThis;
              item.techSync =
                item.techSync == 0 || item.techSync == null
                  ? "--"
                  : item.techSync;
            });
            this.dataList = res.data;
            this.DataMax = this.dataList[0].addSync;
            this.DataMin = this.dataList[0].addSync;
            for (var i = 0; i < this.dataList.length - 1; i++) {
              this.DataMax =
                this.DataMax < this.dataList[i + 1].addSync
                  ? this.dataList[i + 1].addSync
                  : this.DataMax;
              this.DataMin =
                this.DataMin > this.dataList[i + 1].addSync
                  ? this.dataList[i + 1].addSync
                  : this.DataMin;
            }
            this.dataListTable = JSON.parse(JSON.stringify(this.dataList));
            this.getInverstMap();
          } else {
            this.dataListTable = [];
            this.DataMax = 0;
            this.DataMin = 0;
            this.dataList = [];
            this.getInverstMap();
          }
        });
    },
    //处理数据
    convertData(geoCoordMap, data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].addSync / 2),
          });
        }
      }
      return res;
    },
    //轮播切换tooltips
    autohover(inverstChart, num) {
      var count = 0;
      var timeTicket = null;
      timeTicket && clearInterval(timeTicket);
      timeTicket = setInterval(function () {
        inverstChart.dispatchAction({
          type: "downplay",
          seriesIndex: 1,
        });
        inverstChart.dispatchAction({
          type: "highlight",
          seriesIndex: 1,
          dataIndex: count,
        });
        inverstChart.dispatchAction({
          type: "showTip",
          seriesIndex: 1,
          dataIndex: count,
        });
        if (count >= num) {
          count = 0;
        }
        count++;
      }, 1000 * 3);
      inverstChart.on("mouseover", function (params) {
        clearInterval(timeTicket);
        inverstChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
        });
        inverstChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: params.dataIndex,
        });
        inverstChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: params.dataIndex,
        });
      });
      inverstChart.on("mouseout", function () {
        timeTicket && clearInterval(timeTicket);
        timeTicket = setInterval(function () {
          inverstChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
          });
          inverstChart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            dataIndex: count,
          });
          inverstChart.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: count,
          });
          if (count >= num) {
            count = 0;
          }
          count++;
        }, 1000 * 3);
      });
    },
    //地图
    getInverstMap() {
      let _this = this;

      function getMap(data) {
        _this.$echarts.registerMap("mapJson", data);
        var myMap = _this.$echarts.init(document.getElementById("map"));
        _this.setInverstOption(myMap);
      }

      _this.$axios
        .get(`/system/config/selectRegionAndVersion`)
        .then((result) => {
          if (result.data.data.region && result.data.data.version) {
            _this.$axios
              .get(
                `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=json.url&version=${result.data.data.version}`
              )
              .then((result) => {
                var url = `${result.data.data.value}${_this.seatList[0].parentCode}.json`;
                this.$http.get(url).then(function (res) {
                  var body = res.body;
                  if (!body.status) {
                    alert("请求出错！");
                  }
                  getMap(body);
                });
              });
          } else {
            return;
          }
        });
    },
    //地图应用配置
    setInverstOption(inverstChart) {
      let _this = this;
      var inverstMapOption = {
        color: ["#D01864", "#F2F832", "#25CEF3"],
        backgroundColor: "rgba(255,255,255,0)", //背景色
        // title: {
        //   text: "全市工业增加值情况", //标题内容
        //   x: "center", //标题位置
        //   textStyle: {
        //     color: "rgba(0,0,0,0.7)", //标题颜色
        //     fontSize: 18,
        //   },
        //   top: 0,
        // },
        tooltip: {
          //提示信息
          trigger: "item",
          formatter: function (params) {
            let addTotal;
            for (var i = 0; i < _this.dataList.length; i++) {
              if (_this.dataList[i].name == params.name) {
                addTotal = _this.dataList[i].addThis;
                break;
              }
            }
            if (!addTotal) {
              addTotal = 0;
            }
            if (!params.value) {
              params.value = 0;
            }
            if (typeof params.value[2] == "undefined") {
              return (
                params.name +
                " : " +
                "<br/>" +
                "工业增加值增速：" +
                params.value +
                "%" +
                "<br/>" +
                "工业增加值：" +
                addTotal +
                "亿元"
              );
            } else {
              return (
                params.name +
                " : " +
                "<br/>" +
                "工业增加值增速：" +
                params.value[2] * 2 +
                "%" +
                "<br/>" +
                "工业增加值：" +
                addTotal +
                "亿元"
              );
            }
          },
          extraCssText: "background:#0ADAFF;padding:20px 10px", //编辑tooltip的css样式
        },

        visualMap: {
          //左下角数据颜色映射
          max: _this.DataMax,
          min: _this.DataMin,
          left: 0,
          top: 20,
          itemWidth: 10,
          itemHeight: 150,
          calculable: true,
          show: true,
          inRange: {
            color: ["#25CEF3", "#F2F832", "#D01864"],
          },
          textStyle: {
            color: "#333",
          },
        },
        geo: {
          //地图配置
          map: "mapJson",
          zoom: 1,
          roam: true, //开启缩放scale 和拖动move  true 同时开启
          aspectScale: 1, //地图长宽比
          selectedMode: "single", //鼠标点击选中
          label: {
            normal: {
              show: true,
              color: "#000",
              fontSize: 11,
            },
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#2B91B7",
              borderColor: "#111",
              shadowBlur: 1,
              shadowColor: "#5F6476",
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
            emphasis: {
              areaColor: "#2B91B7",
              shadowBlur: 1,
              shadowColor: "#5F6476",
              shadowOffsetX: 5,
              shadowOffsetY: 5,
            },
          },
        },
        series: [
          {
            name: "红色代表增涨最多",
            type: "effectScatter", //涟漪特效散点图
            silent: true,
            showEffectOn: "render", //涟漪特效展示时机
            rippleEffect: {
              //涟漪特效配置
              scale: 15, //涟漪扩散倍数
              period: 10, //涟漪动画周期
              // brushType: 'stroke'
            },
            hoverAnimation: true,
            coordinateSystem: "geo",
            data: _this //暂时自定义处理数据
              .convertData(_this.geoCoordMap, _this.dataList),
            symbolSize: function (val) {
              //图标大小
              return 0;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false,
                color: "#fff",
              },
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              emphasis: {
                borderColor: "#fff",
                borderWidth: 1,
              },
            },
            zlevel: 1,
          },
          {
            type: "map",
            map: "mapJson",
            geoIndex: 0,
            aspectScale: 1, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            roam: false,
            animation: false,
            data: _this.dataList.map((res) => {
              res = { name: res.name, value: res.addSync };
              return res;
            }),
            itemStyle: {
              normal: {
                areaColor: "#031525",
                borderColor: "#FFFFFF",
              },
              emphasis: {
                areaColor: "#2B91B7",
              },
            },
          },
        ],
      };
      inverstChart.setOption(inverstMapOption);
      _this.autoShow(_this.dataList, inverstChart);
    },

    //自动轮播数据展示  开始
    autoShow(data, obj) {
      var dom = obj.getDom();
      var pw = dom.clientWidth || dom.offsetWidth;
      var i = 0,
        fw;
      if (fw) {
        clearInterval(fw);
      }
      fw = setInterval(function () {
        i == data.length ? (i = 0) : (i = i * 1);
        obj.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: i,
          position: function (point, params, dom, rect, size) {
            return {
              right: 40,
              top: 0,
            };
          },
        });
        i++;
      }, 2000);
      obj.on("mouseover", function (params) {
        dom.lastElementChild.className = "";
        clearInterval(fw);
      });
      obj.on("mouseout", function () {
        clearInterval(fw);
        fw = setInterval(function () {
          i == data.length ? (i = 0) : (i = i * 1);
          obj.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: i,
            position: function (point, params, dom, rect, size) {
              return {
                right: 40,
                top: 0,
              };
            },
          });
          i++;
        }, 2000);
      });
    },
    //自动轮播数据展示  结束
    // 普通图表自动播放
    normalTable(echart, num) {
      var index = 0; //播放所在下标
      var mTime = null;
      window.clearInterval(mTime);
      mTime = setInterval(function () {
        echart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index > num) {
          index = 0;
        }
      }, 2000);
    },
    //区域检测
    areaEcharts(data) {
      let _this = this;
      //区域监测
      var areaLeft = _this.$echarts.init(
        document.querySelector(".areaChartsLeft")
      );
      var areaRight = _this.$echarts.init(
        document.querySelector(".areaChartsRight")
      );
      areaLeft.setOption(workBenchAreaL(data));
      areaRight.setOption(workBenchAreaR(data));
    },
    //投资检测
    investEcharts(data) {
      let _this = this;
      //投资监测
      var industryLeft = _this.$echarts.init(
        document.querySelector(".industryChartsLeft")
      );
      var indestryRight = _this.$echarts.init(
        document.querySelector(".industryChartsRight")
      );
      industryLeft.setOption(workBenchIndustryL(data));
      indestryRight.setOption(workBenchIndustryR(data));
    },
    //园区检测
    gardenEcharts(data) {
      let _this = this;
      //园区监测
      var gardenLeft = _this.$echarts.init(
        document.querySelector(".gardenChartsLeft")
      );
      var gardenRight = _this.$echarts.init(
        document.querySelector(".gardenChartsRight")
      );
      gardenLeft.setOption(workBenchGardenL(data));
      gardenRight.setOption(workBenchGardenR(data));
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
      this.times = this.defaultMonthValue;
      this.year = year;
      //下面是几个if
      if (month >= 1 && month <= 3) {
        this.quarter = 1;
        this.halfyeartime = 1;
        return year + "-" + "01" + "," + year + "-" + "03";
      } else if (month >= 4 && month <= 6) {
        this.quarter = 2;
        this.halfyeartime = 2;
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        this.quarter = 3;
        this.halfyeartime = 3;
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        this.quarter = 4;
        this.halfyeartime = 4;
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
  },
  mounted() {
    this.$axios
      .get("/business/workBench/searchParkReportSetting?code=003")
      .then((res) => {
        let dateType = res.data.reportCycle;
        if (dateType == 0) {
          this.dataRange = "month";
        } else if (dateType == 1) {
          this.dataRange = "quarter";
        } else if (dateType == 2) {
          this.dataRange = "halfyear";
        } else if (dateType == 3) {
          this.dataRange = "year";
        }

        if (this.dataRange == "month") {
          let timeT = new Date();
          this.cheTime = `${timeT.getFullYear()}-${this.need0(
            timeT.getMonth() + 1
          )}`;
          this.gardenTime = `${timeT.getFullYear()}-${this.need0(
            timeT.getMonth() + 1
          )}`;
        } else if (this.dataRange == "halfyear") {
          let timeT;
          if (this.halfyeartime == 3 || this.halfyeartime == 4) {
            timeT = this.year + "-07";
          } else {
            timeT = this.year + "-01";
          }
          this.cheTime = timeT;
        } else if (this.dataRange == "quarter") {
          let timeT;
          if (this.quarter == 1) {
            timeT = this.year + "-01";
          } else if (this.quarter == 2) {
            timeT = this.year + "-04";
          } else if (this.quarter == 3) {
            timeT = this.year + "-07";
          } else if (this.quarter == 4) {
            timeT = this.year + "-10";
          }
          this.cheTime = timeT;
        } else if (this.dataRange == "year") {
          let timeT = new Date();
          this.cheTime = timeT.getFullYear() + "-01";
          this.yearVal = timeT.getFullYear() + "";
        }

        this.changeGardenBtn("工业销售产值", this.cheTime);
      });

    this.changeAreaBtn("工业增加值");
    this.changeInvestBtn("工业投资");

    this.changeZbBtn(1);
    this.changeGyjgBtn("工业增加值");
    this.changeCompanyNumTime();
    this.changeQyxzTime();
    this.cutTableList();
  },
  watch: {
    dataList: "getInverstMap",
  },
};
</script>
<style>
@import url("../../../../assets/styles/elementUI.css");
</style>
<style lang="less" scoped>
/**清除浮动 */
.clearfix:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  /* 触发 hasLayout */
  zoom: 1;
}
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.part1_box {
  position: relative;
  padding: 30px 10px 20px;
  box-shadow: 0px 0px 50px #ccc;
  margin-bottom: 20px;
  .title {
    font-size: 18px;
    line-height: 20px;
    color: rgba(0, 0, 0, 1);
    padding-left: 20px;
  }
}

#map {
  min-height: 500px;
}
@media (max-width: 1200px) {
  #map {
    min-height: 300px;
  }
}

.part_2 {
  width: 100%;
  min-height: 450px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 50px #ccc;
  padding: 20px;

  .title {
    margin-bottom: 6px;
    font-size: 18px;
    line-height: 20px;
    color: rgba(0, 0, 0, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18px;
      font-weight: 400;
      line-height: 20px;
      color: rgba(0, 0, 0, 1);
    }
    .button {
      flex: 1;
      .el-button {
        margin-bottom: 6px;
        margin-right: 8px;
        margin-left: 0;
      }
    }
  }
  @media (max-width: 1200px) {
    .title {
      font-size: 14px;
      line-height: 16px;
      color: rgba(0, 0, 0, 1);
    }
  }
  .divHeight {
    height: 440px;
  }
  @media (max-width: 1200px) {
    .divHeight {
      height: 360px;
    }
  }
  .chartBox {
    display: flex;
    margin-top: 20px;
    justify-content: space-around;
    & > div {
      width: 100%;
      height: 360px;
    }
    #companyNum {
      width: 100%;
    }
    #qyxz {
      width: 100%;
    }
  }
}
</style>